import React, { createContext, useContext, useState, useEffect } from 'react';

export const THEMES = [
  { key: 'default', name: 'Emerald Night', swatch: ['#070E0C', '#00E699'] },
  { key: 'porcelain', name: 'Porcelain', swatch: ['#F0F3F0', '#00A06C'] },
  { key: 'indigo', name: 'Midnight Indigo', swatch: ['#090B1A', '#818CF8'] },
  { key: 'amber', name: 'Amber Noir', swatch: ['#130E08', '#F5B042'] },
];

const ThemeCtx = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem('tasco_theme') || 'default');

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'default') root.removeAttribute('data-theme');
    else root.setAttribute('data-theme', theme);
    localStorage.setItem('tasco_theme', theme);
  }, [theme]);

  return <ThemeCtx.Provider value={{ theme, setTheme }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
